import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { logoutUser } from '@/entities/user'
import { isTokenExpired } from '@/shared/lib/JWTTokenHelpers'
import { useAppDispatch, useAppSelector } from '@/shared/store'

export type OnboardingRouteProps = {
  children: React.ReactNode
}

export const OnboardingRoute: React.FC<OnboardingRouteProps> = ({ children }) => {
  const session = useAppSelector(state => state.session)
  const user = useAppSelector(state => state.user)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  // Check session and navigate user as appropriate
  useEffect(() => {
    const isSessionExpired = isTokenExpired(session.accessToken) || session.token === null

    if (isSessionExpired) {
      dispatch(logoutUser()).then(() => {
        navigate('/', { replace: true })
      })

      return
    }

    if (!session.isEmailVerified) {
      navigate('/verify-email', { replace: true })
    }

    if (session.isEmailVerified && user.client && user.client.isOnboarded) {
      navigate('/operations', { replace: true })
    }
  }, [session, user?.client, dispatch, navigate])

  return (
    <>
      {session.accessToken !== null && session.token !== null && children}
    </>
  )
}
